<template>
    <div>
        <div v-if="item">
            <div class="product-card card br p-t-3 p-b-3 m-b-4">
                <div class="card-content row row-middle row-compress">
                    <div class="slat-content column">
                        <h4 class="card-title c-primary f-s-4 m-b-0">{{ getMembership(item.membership_id).name }}</h4>
                        <p class="c-medium-tint f-s-3">{{ formattedPrice(item.pricing_plan) }} • {{ types[item.pricing_plan.type] }}</p>
                    </div>
                    <div class="slat-aside text-right m-r-4">
                        <a class="btn btn-text btn-text--accent open-modal" data-modal="modal-upsell" v-on:click="editUpsell">{{ trans('Edit Upsell') }}</a>
                    </div>
                </div>
                <input type="hidden" v-bind:name="'encoded_id'" v-bind:value="item.encoded_id" />
                <input type="hidden" v-bind:name="'membership_id'" v-bind:value="item.membership_id" />
                <input type="hidden" v-bind:name="'pricing_plan[name]'" v-bind:value="item.pricing_plan.name" />
                <input type="hidden" v-bind:name="'pricing_plan[type]'" v-bind:value="item.pricing_plan.type" />
                <input type="hidden" v-bind:name="'pricing_plan[price]'" v-bind:value="item.pricing_plan.price" />
                <input type="hidden" v-bind:name="'pricing_plan[setup_price]'" v-bind:value="item.pricing_plan.setup_price" />
                <input type="hidden" v-bind:name="'pricing_plan[trial_period_days]'" v-bind:value="item.pricing_plan.trial_period_days" />
                <input type="hidden" v-bind:name="'pricing_plan[interval]'" v-bind:value="item.pricing_plan.interval" />
                <input type="hidden" v-bind:name="'pricing_plan[currency]'" v-bind:value="item.pricing_plan.currency" />
                <input type="hidden" v-bind:name="'pricing_plan[interval_count]'" v-bind:value="item.pricing_plan.interval_count" />
                <input type="hidden" v-bind:name="'original_price'" v-bind:value="item.original_price" />
            </div>
        </div>
        <div v-else class="text-center p-t-3">
            <button v-on:click="newUpsell" type="button" class="btn btn-text btn-text--accent btn-icon m-b-4">
                <span class="icon i-container i-filled-accent">
                    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon i-size-small inline"><g class="icon"><path d="M11 5v14h2V5z"></path><path d="M19 11H5v2h14z"></path></g></svg>
                </span>
                {{  trans('Add Upsell') }}
            </button>
        </div>
        <upsell-modal
            v-if="modalShow"
            ref="modal-upsell"
            v-bind:parent="parentMembership"
            v-bind:memberships="memberships"
            v-on:close="closeModal"
            v-on:save="saveUpsell"
            v-on:delete="deleteUpsell"
        ></upsell-modal>

        <input type="hidden" v-bind:name="'for_removal[' + index + ']'" v-for="(id, index) in forRemoval" v-bind:value="id" v-bind:key="'remove-' + id" />
    </div>
</template>
<script>
import UpsellModal from './UpsellModal.vue';
import { PLAN_TYPE_ONE_TIME, PLAN_TYPE_SUBSCRIPTION, PLAN_TYPE_INSTALLMENT_PLAN } from '../../constants.js';
import HasFormattedPrice from '../../mixins/HasFormattedPrice.js';
import TranslateInterval from '../../mixins/TranslateInterval.js';
import { EventBus } from '../../event-bus.js';

export default {
    mixins: [
        TranslateInterval,
        HasFormattedPrice
    ],
    components: {
        UpsellModal
    },
    props: {
        upsell: {
            type: Object,
            default: null
        },
        memberships: {
            type: Array,
            required: true
        },
        parentMembership: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            item: this.upsell
                ? {
                    ...this.upsell,
                    'pricing_plan': {
                        ...this.upsell.pricing_plan,
                        'price': this.upsell.pricing_plan.price / 100,
                        'setup_price': this.upsell.pricing_plan.setup_price / 100,
                    },
                    'original_price': this.upsell.original_price ? this.upsell.original_price / 100 : null,
                }
                : null
            ,
            modal: null,
            modalShow: false,
            forRemoval: [],
            types: {
                [PLAN_TYPE_ONE_TIME]: this.trans('One-time Payment'),
                [PLAN_TYPE_SUBSCRIPTION]: this.trans('Subscription'),
                [PLAN_TYPE_INSTALLMENT_PLAN]: this.trans('Installment Plan'),
            },
        }
    },
    methods: {

        newUpsell() {
            this.modalShow = true;

            this.$nextTick(() => {
                this.$refs['modal-upsell'].show = true;
            });
        },
        /**
         * Saves the upsell item.
         * Sets the item to the current upsell and closes the modal.
         * Emits a form:check event after the next tick.
         * @param {Object} upsell - The upsell item to save.
         */
        saveUpsell(upsell) {
            this.item = {
                ...upsell,
                'pricing_plan': {
                    ...upsell.pricing_plan,
                    'price': upsell.pricing_plan.price,
                    'setup_price': upsell.pricing_plan.setup_price,
                },
                'original_price': upsell.original_price ? upsell.original_price : null,
            };
            this.closeModal();

            this.$nextTick(() => {
                EventBus.$emit('form:check');
            });
        },
        /**
         * Deletes the upsell item.
         * If the item has an encoded_id, it is added to the forRemoval array.
         * If not, it emits a form:clean event.
         */
        deleteUpsell() {
            if (this.item.encoded_id) {
                this.forRemoval.push(this.item.encoded_id);

                EventBus.$emit('form:dirty');
            } else {
                EventBus.$emit('form:clean');
            }

            this.item = null;
            this.closeModal();
        },

        editUpsell() {
            this.modalShow = true;

            this.$nextTick(() => {
                this.$refs['modal-upsell'].show = true;
                this.$refs['modal-upsell'].loadUpsell(this.item);
            });
        },

        closeModal() {
            this.modalShow = false;
        },
        /**
         * Retrieves the membership object by its ID.
         * @param {number} membershipId - The ID of the membership to retrieve.
         * @returns {Object|null} The membership object if found, otherwise null.
         */
        getMembership(membershipId) {
            return this.memberships.find(membership => membership.id === membershipId);
        },
    },
}
</script>